// export const BASE_API = 'http://localhost:8888';

// export const BASE_API = "http://159.65.3.155:8888";
// export const BASE_API = 'https://api-dev.siammusicmembers.com';

export const BASE_API = 'https://api.siammusicmembers.com';

export const BASE_PATH_API = "";
